import React, { useContext } from 'react'
import { BlogContext, BlogProvider } from './BlogContext'
import BlogCategories from './BlogCategories'
import ArticlePreviewLg from './ArticlePreviewLg'
import ArticlePreview from './ArticlePreview'
import usePagination from '@/utils/usePagination'
import clsx from 'clsx'
import * as css from './BlogListing.module.css'

const App = () => {
	const { posts, $category } = useContext(BlogContext)

	// filter posts by category; show all if category is not set
	const filtered = posts?.filter(({ categories }) => !$category || categories.some(({ name }) => name === $category))

	const { atStart, atEnd, paginatedItems, Pagination } = usePagination({
			items: filtered,
			itemsPerPage: 13,
		})

	const [firstPost, ...otherPosts] = paginatedItems

	return <>
		<BlogCategories />

		<section className={clsx(css.section, 'section grid gap-12')}>
			{!!firstPost && <ArticlePreviewLg post={firstPost} key={firstPost._id} />}

			{!!otherPosts?.length && (
				<ul className="grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-6">
					{otherPosts?.map((post, i) => (
						<li key={post._id}>
							<ArticlePreview post={post} index={i} />
						</li>
					))}
				</ul>
			)}

			<Pagination
				className="flex items-center justify-center gap-8"
				prevClassName={clsx('technical', css.pagination, atStart && css.disabled)}
				nextClassName={clsx('technical', css.pagination, atEnd && css.disabled)}
			/>
		</section>
	</>
}

const BlogListing = () => <BlogProvider children={<App/>} />

export default BlogListing
